export default {
  'component.delBtn.title': '确定删除吗？',
  'component.delBtn.tooltip': '删除',
};
